import React, { useState } from "react";
import "./Team.scss";
import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import David from "../../assets/David.jpg";
import alon from "../../assets/alon.jpg";
import NathanKay from "../../assets/NathanKay.jpg";
import Kosta from "../../assets/Kosta.jpg";
import maimran from "../../assets/mainran.jpg";
import Cali from "../../assets/Cali.jpg";
import Darryl from "../../assets/Darryl.jpg";
import Marco from "../../assets/Marco.jpg";
import { LinkedInIcon } from "../../assets/StoreAsset/StoreAssets";
import { GmailIcon } from "../../assets/StoreAsset/StoreAssets";

const Team = () => {
  const [activeCardIndex, setActiveCardIndex] = useState(0);
  const slidesData = [
    {
      id: 1,
      subTitle: "Dov Leon Maimaran ",
      description: "CCO",
      imageSrc: maimran,
      linkedin:
        "https://www.linkedin.com/in/dov-maimaran-a01815353/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
      email: "dov@uniwalletpay.com",
    },
    {
      id: 2,
      subTitle: "David",
      description: "CEO",
      imageSrc: David,
      linkedin:
        "https://www.linkedin.com/in/david-nezry-47390b2?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
      email: "david@uniwalletpay.com",
    },
    {
      id: 3,
      subTitle: "ALON S JACOBSON",
      description: "Founder and Visionary",
      imageSrc: alon,
      linkedin:
        "https://www.linkedin.com/in/alon-jacobson-a3408257/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
      email: "shlomo@uniwalletpay.com",
    },

    {
      id: 4,
      subTitle: "Nathan Kay",
      description: "COO",
      imageSrc: NathanKay,
      linkedin: "https://www.linkedin.com/in/nathan-kay-nk/",
      email: "nathan@uniwalletpay.com",
    },
    {
      id: 5,
      subTitle: "Kosta",
      description: "Head of Product",
      imageSrc: Kosta,
      linkedin:
        "https://www.linkedin.com/in/kosta-l-7b7823155?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      email: "connect@uniwalletpay.com",
    },
    {
      id: 6,
      subTitle: "Marco Kovalevski",
      description: "Advisor",
      imageSrc: Marco,
      linkedin: "https://www.linkedin.com/in/marco-kowalewski/",
      email: "-",
    },
    {
      id: 7,
      subTitle: "Cali Sue",
      description: "Social Media Marketing Lead",
      imageSrc: Cali,
      linkedin:
        "https://www.linkedin.com/in/calistasue?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
      email: "-",
    },
    {
      id: 8,
      subTitle: "Daryl Naidoo",
      description: "Advisor ",
      imageSrc: Darryl,
      linkedin: "https://www.linkedin.com/in/darylnaidoo/",
      email: "daryl@uniwalletpay.com",
    },
  ];

  const responsive = {
    desktop: {
      breakpoint: { max: 2500, min: 1470 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1600, min: 1170 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: { breakpoint: { max: 1200, min: 300 }, items: 1, slidesToSlide: 1 },
  };

  return (
    <div className="team">
      <h4>Team</h4>
      <h2>Meet the Visionaries behind Uniwallet Pay</h2>
      <div className="cardCarousel">
        <Carousel
          responsive={responsive}
          swipeable={true}
          draggable={true}
          showDots={true}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={1800}
          keyBoardControl={true}
          partialVisible={false} // 👈 IMPORTANT
          centerMode={true}
          customTransition="transform 300ms ease-in-out"
          transitionDuration={500}
          removeArrowOnDeviceType={["tablet", "mobile"]}
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
          afterChange={(nextSlideIndex) => setActiveCardIndex(nextSlideIndex)}
          slidesToSlide={1}
        >
          {slidesData.map((slide, index) => (
            <div
              key={slide.id}
              className={`main_sliderinner ${
                activeCardIndex === index ? "active" : ""
              }`}
            >
              <div className="main_sliderinner__image">
                <img
                  src={slide.imageSrc}
                  alt={slide.imageSrc}
                  //   style={{ width: "100%", maxWidth: 296, height: 311 }}
                />
              </div>
              <div className="desc">
                <h3>{slide.subTitle}</h3>
                <p>{slide.description}</p>
                <span className="teamSocialIcon">
                  {slide.linkedin && (
                    <Link to={slide.linkedin} target="_blank">
                      <LinkedInIcon />
                    </Link>
                  )}
                  <a
                    href={`https://mail.google.com/mail/?view=cm&to=${slide.email}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <GmailIcon />
                  </a>
                </span>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default Team;
